import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";

export const VisitsLabel: React.FC<{ topic: string }> = ({ topic }) => {
  const [n, setN] = useState<number | null>(null);

  useEffect(() => {
    let on = true;
    fetch("https://api.besteurogirls.com/track/visit/" + encodeURIComponent(topic), { method: "POST" })
      .then((r) => r.json())
      .then((d) => { if (on && d && typeof d.visits === "number") setN(d.visits); })
      .catch(() => undefined);
    return () => { on = false; };
  }, [topic]);

  if (n === null) return null;
  return (
    <Box sx={{ ml: { md: "auto" }, display: "flex", alignItems: "center", gap: 0.75, fontSize: 13, fontWeight: 700, color: "#9a9aa2" }}>
      <VisibilityIcon sx={{ fontSize: 18 }} />
      Visits: {n.toLocaleString("en-US")}
    </Box>
  );
};
